/**
 * Created by CGuethues on 30.10.2015.
 */

jQuery(document).ready(function(){

  jQuery(".jsFakeBookLoadModuleDiv").click(function(e) {
    createCookie("facebook",'allow',30);
    loadFacebook();
  });

  if( readCookie("facebook")=='allow' ){
    loadFacebook();

    $( window ).resize(function() {
      loadFacebook();
    });
  }

});

function loadFacebook() {
  jQuery(".jsFakeBookLoadModuleDiv").remove();
  var $fbFrame = jQuery("#facebookFrame");
  var fbFrameWidth = $fbFrame.innerWidth() > 310 ? 310 : $fbFrame.innerWidth();

  var $fbFrameDiv = $fbFrame.children('div');
  var fbURL = encodeURI($fbFrameDiv.attr('data-fburl'));
  var fbTabs = $fbFrameDiv.attr('data-fbtabs');
  var fbHideCover = $fbFrameDiv.attr('data-fbhidecover');
  var fbHideFacePile = $fbFrameDiv.attr('data-fbhidefacepile');
  var fbHideCTA = $fbFrameDiv.attr('data-fbhidecta');
  var fbSmallHeader = $fbFrameDiv.attr('data-fbsmallheader');

  fbURL =  fbURL.replace('https://','');
  fbTabs = fbTabs.length ? '&tabs=' + fbTabs : '';
  fbHideCover = fbHideCover ? '&hide_cover=true' : '';
  fbHideFacePile = fbHideFacePile ? '&show_facepile=false' : '';
  fbHideCTA = fbHideCTA ? '&hide_cta=true' : '';
  fbSmallHeader = fbSmallHeader ? '&small_header=true' : '';


  var linkURL = '//www.facebook.com/plugins/page.php?href=https://' + fbURL;
  var linkParam = '&colorscheme=light&show_faces=true&width=' + fbFrameWidth + '&adapt_container_width=true' + fbTabs + fbHideCover + fbHideFacePile + fbHideCTA + fbSmallHeader
  var boxHeight = fbTabs.length ? 500 : 245;

  $fbFrame.children('div').children('iframe').attr('src',linkURL+linkParam);
  $fbFrame.attr('style','display:block');
  $fbFrame.children('div').children('iframe').attr('style','border:none;overflow:hidden;height:' + boxHeight + 'px;');
}


function createCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function fbDeleteCookies(){
  document.cookie = "facebook" + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}
